var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.guideBookPaper)?_c('publication-list',{attrs:{"publishable":_vm.guideBookPaper,"publishable-type":"GuideBookPaper"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }